import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import type { User } from "../services/api";
import { ROUTES_NAMES } from "./Layout";

const MI_CONTENIDO_DEMO_EMAIL_ALLOWLIST = ["esteban@podscope.co"];

function canAccessMiContenidoDemo(user: User): boolean {
  if (user.role === "admin") return true;
  const normalized = user.email?.trim().toLowerCase();
  return (
    normalized !== undefined &&
    MI_CONTENIDO_DEMO_EMAIL_ALLOWLIST.includes(normalized)
  );
}

const MiContenidoDemoRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to={ROUTES_NAMES.AUTH} replace />;
  }

  if (!user || !canAccessMiContenidoDemo(user)) {
    return <Navigate to={ROUTES_NAMES.DASHBOARD} replace />;
  }

  return <>{children}</>;
};

export default MiContenidoDemoRoute;
